export default "__VITE_ASSET__2ZK10DZw__"